import { apiGet, apiPost, mockSuccess } from "@redriver/cinnamon";

const NAMESPACE = "TEMPLATE_DOCUMENTS";
const ActionTypes = {
  DownloadDocument: `${NAMESPACE}/DOWNLOAD_DOCUMENT`,
};

export const downloadTemplateDocument = (document) => {
  return apiGet(ActionTypes.DownloadDocument, "resort-reps/template-document", {
    document,
  });
};
